import React from 'react';

export type StatusBadgeTone = 'success' | 'danger' | 'warning' | 'info' | 'primary' | 'secondary';

type StatusBadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  tone: StatusBadgeTone;
  label: React.ReactNode;
  className?: string;
};

/**
 * Status badge: outlined (toned border + text) with a leading dot in the same
 * tone. The dot inherits the badge text color via `currentColor`.
 *
 * Forwards ref and spreads extra props onto the root span so it can be used
 * as an OverlayTrigger child (tooltips need the ref + hover handlers).
 */
const StatusBadge = React.forwardRef<HTMLSpanElement, StatusBadgeProps>(({ tone, label, className, ...rest }, ref) => (
  <span ref={ref} className={`badge ek-badge ek-badge-outline-${tone}${className ? ` ${className}` : ''}`} {...rest}>
    <span className="ek-badge__dot" />
    {label}
  </span>
));

StatusBadge.displayName = 'StatusBadge';

export default StatusBadge;
